// Hooks
import { useQuery, UseQueryOptions, RequestError } from 'shared/libs/rest';

// Api
import {
  apiGetUserData,
  GetUserDataRequest,
  GetManagerDataResponse,
  QUERY_KEY_GET_MANAGER_DATA,
} from '../apiGetUserData';

// Request hook
export const useGetUserData = (
  params?: GetUserDataRequest,
  options?: UseQueryOptions<
    GetManagerDataResponse,
    RequestError,
    GetManagerDataResponse
  >
) =>
  useQuery<GetManagerDataResponse, RequestError, GetManagerDataResponse>({
    queryKey: [QUERY_KEY_GET_MANAGER_DATA, params],
    queryFn: () => apiGetUserData(params as GetUserDataRequest),
    ...(options || ({} as any)),
  });
